import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import velocity from 'velocity-animate'
import Notifications from 'vue-notification'
import Vuelidate from 'vuelidate';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueGtag from "vue-gtag";
// import VueAnalytics from "vue-analytics"

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(Notifications, { velocity })
Vue.use(Vuelidate);
Vue.use(VueGtag, {
  config: {
    id: process.env.VUE_APP_GA_ID,
    params: {
      send_page_view: false
    }
  }
});

Vue.config.productionTip = false


// Vue.use(VueAnalytics, {
//   id: 'UA-159867598-2',
//   router
// });


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
